import { render } from "./Over.vue?vue&type=template&id=b0840e64&ts=true"
import script from "./Over.vue?vue&type=script&lang=ts"
export * from "./Over.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__